<div *ngIf="!isBusy; else spinner">
  <mat-dialog-content [formGroup]="formGroup">
    <mat-form-field class="form-formatting">
      <textarea matInput placeholder="Description" formControlName="description" rows="20"
                [(ngModel)]="business.description" (keyup)="textAreaChanged()">
      </textarea>
    </mat-form-field>
    <p class="form-formatting" [class.danger]="!formGroup.valid">Characters remaining: {{charRemainingCnt}}</p>
    <p class="form-formatting" [class.danger]="!formGroup.valid">Max number of characters: 2000</p>
  </mat-dialog-content>

  <mat-dialog-actions class="form-formatting">
    <button type="submit" [disabled]="!formGroup.valid" id="saveButton" class="mat-raised-button" (click)="save()">
      Save
    </button>
    <button id="cancelButton" class="mat-raised-button" (click)="cancel()">Cancel</button>
  </mat-dialog-actions>
</div>
<ng-template #spinner>
  <div class="spinnerContainer">
    <mat-spinner  class="spinner" [diameter]="100" [color]="'accent'"></mat-spinner>
  </div>
</ng-template>
